<template>
  <div>
    <div v-if="items && items.length > 0">
      <div 
        v-for="(item, index) in items" 
        :key="`item-${index}`"
      >
        <!-- Use the exact same structure as vue-form-generator from the screenshot -->
        <fieldset class="valid w-full">
          <div 
            class="form-group valid disabled vx-col w-1/3 p-4 field-input"
            :class="{ 'changed-field-highlight': isFieldChanged(item, 'CompanyName') }"
          >
            <label class="form-label" :for="`${itemLabel.toLowerCase().replace(/\s+/g, '-')}-${index}`">{{ itemLabel }}</label>
            <div class="field-wrap">
              <div class="wrapper" :data-changed="isFieldChanged(item, 'CompanyName') ? 'true' : 'false'">
                <input 
                  :id="`${itemLabel.toLowerCase().replace(/\s+/g, '-')}-${index}`"
                  type="text" 
                  :value="getFieldValue(item, 'CompanyName')" 
                  disabled 
                  class="form-control"
                  :data-changed="isFieldChanged(item, 'CompanyName') ? 'true' : 'false'"
                />
              </div>
            </div>
          </div>
          <div 
            class="form-group valid disabled vx-col w-1/3 p-4 field-input"
            :class="{ 'changed-field-highlight': isFieldChanged(item, 'InceptionDate') }"
          >
            <label class="form-label" :for="`inception-date-${index}`">Inception Date</label>
            <div class="field-wrap">
              <div class="wrapper" :data-changed="isFieldChanged(item, 'InceptionDate') ? 'true' : 'false'">
                <input 
                  :id="`inception-date-${index}`"
                  type="text" 
                  :value="getFieldValue(item, 'InceptionDate')" 
                  disabled 
                  class="form-control"
                  :data-changed="isFieldChanged(item, 'InceptionDate') ? 'true' : 'false'"
                />
              </div>
            </div>
          </div>
          <div 
            class="form-group valid disabled vx-col w-1/3 p-4 field-input"
            :class="{ 'changed-field-highlight': isFieldChanged(item, 'ExpiryDate') }"
          >
            <label class="form-label" :for="`expiry-date-${index}`">Expiry Date</label>
            <div class="field-wrap">
              <div class="wrapper" :data-changed="isFieldChanged(item, 'ExpiryDate') ? 'true' : 'false'">
                <input 
                  :id="`expiry-date-${index}`"
                  type="text" 
                  :value="getFieldValue(item, 'ExpiryDate')" 
                  disabled 
                  class="form-control"
                  :data-changed="isFieldChanged(item, 'ExpiryDate') ? 'true' : 'false'"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div v-else class="p-4 text-center">
      <p>{{ emptyMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelationshipList',
  props: {
    items: {
      type: Array,
      required: true
    },
    itemLabel: {
      type: String,
      required: true
    },
    emptyMessage: {
      type: String,
      required: true
    },
    // New props for highlighting
    originalItems: {
      type: Array,
      default: () => []
    },
    isChangedSection: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // Check if a specific field within an item has changed and has a value
    // Uses API-provided _changedFields metadata
    isFieldChanged(item, fieldName) {
      if (!this.isChangedSection) {
        // For "Original Values" section, never highlight (never red)
        return false;
      }
      
      // For "New Values" section, check if field is in API-provided _changedFields array
      // API determines which fields changed dynamically
      if (item._changedFields && item._changedFields.includes(fieldName)) {
        // Only highlight if the field has a value
        return this.hasFieldValue(item, fieldName);
      }
      
      return false;
    },
    
    // Check if a field has a value in the item
    // Fully dynamic - works with any field name from API
    hasFieldValue(item, fieldName) {
      if (!item) return false;
      
      // Check if field exists directly on item
      if (item[fieldName] !== undefined && item[fieldName] !== null && item[fieldName] !== '') {
        return true;
      }
      
      // Check if field exists in pivot structure
      if (item.pivot && item.pivot[fieldName] !== undefined && item.pivot[fieldName] !== null && item.pivot[fieldName] !== '') {
        return true;
      }
      
      return false;
    },
    
    // Get field value, returning blank string instead of 'N/A' for missing values
    // Fully dynamic - works with any field name from API
    getFieldValue(item, fieldName) {
      if (!item) return '';
      
      // Check if field exists directly on item
      if (item[fieldName] !== undefined && item[fieldName] !== null && item[fieldName] !== '') {
        return item[fieldName];
      }
      
      // Check if field exists in pivot structure
      if (item.pivot && item.pivot[fieldName] !== undefined && item.pivot[fieldName] !== null && item.pivot[fieldName] !== '') {
        return item.pivot[fieldName];
      }
      
      return '';
    }
  }
};
</script>

<style lang="scss">
// Use the exact same highlighting CSS as ChangeLogsForm.vue
.changed-field-highlight,
[data-changed="true"] {
  background-color: rgba(255, 234, 234, 1) !important;
  border-radius: 4px;
  transition: all 0.3s ease;

  input,
  select,
  textarea {
    background-color: rgba(255, 234, 234, 1) !important;
    transition: all 0.3s ease;

    &:focus {
      border-color: rgba(255, 234, 234, 0.4) !important;
      box-shadow: 0 0 0 2px rgba(255, 234, 234, 1) !important;
    }
  }

  label {
    font-weight: 600;
    color: rgba(255, 0, 0, 0.8) !important; // Red labels for highlighted fields
  }
}
</style>
